import { Injectable, EventEmitter } from '@angular/core';
import { SplitFactory } from '@splitsoftware/splitio';
import { ClientService } from './client.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class SplitService {
  public treatmentResponse = new EventEmitter<{ splitName: string, isTreatmentOn: boolean }>();

  private factory: SplitIO.ISDK;
  private authKey: string;
  private user_client: SplitIO.IClient;
  private splitView: SplitIO.SplitView;
  private clientService: ClientService;
  private isProd: boolean;

  public constructor(
    clientService: ClientService
  ) {
    this.clientService = clientService;
    this.isProd = environment.production;
  }

  public getSplitTreatment(splitName: string): void {
    // TODO: Make genric for all splits
    // Get environment
    if (this.isProd) {
      this.authKey = 'kubqgv15d93dehqpju10v9cnbt6ekakk1jd1';
    }
    else {
      this.authKey = '8lf6gmlgspn3c5s83cfvjf73mv5bao7voseu';
    }

    // Use shop order id from sessionstorage as user id
    const user_id = sessionStorage.getItem('shop.order.id');
    // console.log('user_id', user_id);

    // Instantiate the SDK
    this.factory = SplitFactory({
      core: {
        // API key from Admin settings -> workspace settings -> API keys (https://app.split.io/)
        authorizationKey: this.authKey,
        // unique identifier for your user
        key: user_id
      },
    });

    // Enable this to see SDK logging in the console og the browser inspector
    // factory.Logger.enable();

    // Get the manager instance
    const manager: SplitIO.IManager = this.factory.manager();
    manager.once(manager.Event.SDK_READY, () => {
      this.splitView = manager.split(splitName);

      if (this.splitView.killed === true) {
        return;
      }
      else {
        this.getTreatmentFromClient(splitName);
      }
    });
  }

  private getTreatmentFromClient(splitName: string): void {
    // Get the client instance
    this.user_client = this.factory.client();

    // We set the client to listen for the SDK_READY event triggered by the SDK before asking for an evaluation.
    // If asked to get treatment before this, SDK will return control treatment.
    this.user_client.ready().then(() => {
      // Returns treatment based on the SPLIT_NAME and the key variables you passed when instantiating the SDK. (PageHeaderSplit)
      const treatment: SplitIO.Treatment = this.user_client.getTreatment(splitName);

      // console.log('treatment: ', treatment);
      // console.log('splitname: ', splitName);

      if (treatment === 'on') {
        // add info to clientService about the A/B split 
        this.clientService.addSplitTestMetaData('Name', splitName);
        this.clientService.addSplitTestMetaData('Segment', 'on treatment');
        this.treatmentResponse.emit({ 'splitName': splitName, 'isTreatmentOn': true });
      }
      else if (treatment === 'off') {
        // add info to clientService about the A/B split 
        this.clientService.addSplitTestMetaData('Name', splitName);
        this.clientService.addSplitTestMetaData('Segment', 'off treatment');
        this.treatmentResponse.emit({ 'splitName': splitName, 'isTreatmentOn': false });
      }
      // Control treatment
      else {
        // add info to clientService about the A/B split 
        this.clientService.addSplitTestMetaData('Name', splitName);
        this.clientService.addSplitTestMetaData('Segment', 'control treatment');
        this.treatmentResponse.emit({ 'splitName': splitName, 'isTreatmentOn': false });
      }
    });
  }

  public shutdownSplitSDK(): void {
    if (this.user_client) {
      this.user_client.destroy();
      this.user_client = null;
    }
  }
}
